<ion-content class="bg-color ion-content user-details">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <h4 class="mat-title-header">Filter Details</h4>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <div class="list-info">
                <span>Index Name</span>
                <span>{{groupDetailsObj?.index_name}}</span>
              </div>
              <div class="list-info">
                <span>Column Name</span>
                <span>{{groupDetailsObj?.column_name}}</span>
              </div>
              <div class="list-info">
                <span>Condition Flag</span>
                <span>{{groupDetailsObj?.condition_flag}}</span>
              </div>
              <div class="list-info">
                <span>Column Value</span>
                <span>{{groupDetailsObj?.column_value}}</span>
              </div>
              <div class="list-info">
                <span>Column Type</span>
                <span>{{groupDetailsObj?.column_type}}</span>
              </div>
              <div class="btn-signup-grid">
                <button mat-raised-button type="submit" (click)="goToGroupFilterList()" class="btn btn-signup">Go
                  Back</button>
              </div>

            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>